/**
 *  @class
 *  @function CountdownTimer
 */
if (!customElements.get('countdown-timer')) {
	class CountdownTimer extends HTMLElement {
		constructor() {
			super();
			// Unix timestamp (seconds) of the drop, so no timezone conversion is needed
			this.countDownDate = parseInt(this.dataset.timestamp, 10) * 1000;
		}
		connectedCallback() {
			let _this = this;
			const updateTime = function () {

				// Get todays date and time
				const now = new Date().getTime();
				// Find the distance between now an the count down date
				const distance = _this.countDownDate - now;
				// Time calculations for days, hours, minutes and seconds
				const days = Math.floor(distance / (1000 * 60 * 60 * 24));
				const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
				const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
				const seconds = Math.floor((distance % (1000 * 60)) / 1000);
				if (_this.querySelector('.seconds .countdown-timer--column--number')) {
					if (distance < 0) {
						_this.querySelector('.days .countdown-timer--column--number').innerHTML = 0;
						_this.querySelector('.hours .countdown-timer--column--number').innerHTML = 0;
						_this.querySelector('.minutes .countdown-timer--column--number').innerHTML = 0;
						_this.querySelector('.seconds .countdown-timer--column--number').innerHTML = 0;
						if (_this.querySelector('[data-countdown-subheading]')) {
							_this.querySelector('[data-countdown-subheading]').innerHTML = 'Now Live';
						}
						if (_this.querySelector('[data-countdown-banner-icons]')) {
							_this.querySelector('[data-countdown-banner-icons] .icon-timer').classList.add('is-hidden');
							_this.querySelector('[data-countdown-banner-icons] .icon-down-arrows-single').classList.remove('is-hidden');
						}
						if ((_this.hasAttribute('data-countdown-banner-pdp')) || (_this.hasAttribute('data-banner-refresh'))) {
							location.reload();
						}
						var timer_colums = _this.querySelectorAll('.countdown-timer--column');
						timer_colums.forEach(column => {
							column.style.display = 'none'
						});
						_this.querySelector('.countdown-banner--timer').classList.add('now-live');
						if(document.querySelector('.countdown-banner')){
							document.querySelector('.countdown-banner').remove();
						}
						if(document.querySelector('.product__locked-icon')){
							document.querySelector('.product__locked-icon').remove();
						}
						var elemsToHidePreDrop = document.querySelectorAll('[data-drop]');
						if(elemsToHidePreDrop){
							elemsToHidePreDrop.forEach(elem => {
								elem.classList.remove('is-hidden');
							});
						}
						if (document.querySelector('.product-information--locked')) document.querySelector('.product-information--locked').classList.remove('product-information--locked');
					} else {
						var elemsToHidePreDrop = document.querySelectorAll('[data-drop]');
						if(elemsToHidePreDrop){
							elemsToHidePreDrop.forEach(elem => {
								elem.remove();
							});
						}
						requestAnimationFrame(updateTime);
						_this.querySelector('.days .countdown-timer--column--number').innerHTML = CountdownTimer.addZero(days);
						if (_this.hasAttribute('data-hide-empty-days')) {
							_this.querySelector('.days').style.display = days > 0 ? '' : 'none';
						}
						_this.querySelector('.hours .countdown-timer--column--number').innerHTML = CountdownTimer.addZero(hours);
						_this.querySelector('.minutes .countdown-timer--column--number').innerHTML = CountdownTimer.addZero(minutes);
						_this.querySelector('.seconds .countdown-timer--column--number').innerHTML = CountdownTimer.addZero(seconds);
						if (_this.querySelector('[data-countdown-banner-icons]')) {
							_this.querySelector('[data-countdown-banner-icons] .icon-down-arrows-single').classList.add('is-hidden');
						}
					}
				} else {
					if (_this.querySelector('[data-countdown-banner-icons]')) {
						_this.querySelector('[data-countdown-banner-icons] .icon-down-arrows-single').classList.add('is-hidden');
					}
				}
			};
			requestAnimationFrame(updateTime);
		}
		static addZero(x) {
			return (x < 10 && x >= 0) ? "0" + x : x;
		}
	}
	customElements.define('countdown-timer', CountdownTimer);
}